import {BUILD_TYPE, getBuildType} from '@voltmoney/micro-frontend';

export const BASE_URL = {
  [BUILD_TYPE.PARTNER_STAGING]: 'https://api.staging.voltmoney.in',
  [BUILD_TYPE.PARTNER_PRODUCTION]: 'https://api.voltmoney.in',
};

export const config = {
  // @ts-ignore
  URL: BASE_URL[getBuildType()],
};
export const StoreKey = {
  isPledgeFirstTime: 'isPledgeFirstTime',
  isLoadedFirstTime: 'is_Loaded_First_Time',
  accessToken: 'access_token',
  refreshToken: 'refresh_token',
  userContext: 'user_context',
  UTM_PARAMS: 'UTM_PARAMS',
};
export const api = {
  login: `${config.URL}/api/client/auth/requestOtp/`,
  verifyOtp: `${config.URL}/api/client/auth/verifyOtp/`,
  investorLink: `${config.URL}/app/partner/referralLink/borrower/`, //{partnerAccountId}
  advisorLink: `${config.URL}/app/partner/referralLink/partner/`, //{partnerAccountId}
  partnerUserContext: `${config.URL}/app/partner/user`,
  updatePartnerUserContext: `${config.URL}/app/partner/accountAttributes/`,
  getPartnerName: `${config.URL}/app/partner/details/refCode/`,
  getPartnerReport: `${config.URL}/app/analytics/partner/`,
  generateLinkPartnerRefCode: `${config.URL}/app/partner/referralLink/app/borrower/`,
};
